import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/HelpOutline";
import moment from "moment-timezone";
import React from "react";
import { languages } from "../../constants/languages";
import SelectPoulesContainer from "../../containers/schedule/SelectPoulesContainer";
import SelectDays from "./SelectDays";
import SelectFields from "./SelectFields";
import SelectRounds from "./SelectRounds";

const MatchesPlanner = (props) => {
  let moreRoundsThanDays =
    props.selectedDays.length < props.selectedRounds.length;

  let allFieldsHaveEndTimes = true;
  props.selectedFields.forEach((f) => {
    props.selectedDays.forEach((d) => {
      if (d.value === "0") {
        if (!((props.tournament.fields || {})[f.value] || {}).endTime) {
          allFieldsHaveEndTimes = false;
        }
      } else {
        let endTime =
          ((props.tournament.fields || {})[f.value] || {})[d.value + "end"] !==
          undefined
            ? ((props.tournament.fields || {})[f.value] || {})[d.value + "end"]
            : ((props.tournament.fields || {})[f.value] || {}).endTime || "";
        if (!endTime) {
          allFieldsHaveEndTimes = false;
        }
      }
    });
  });
  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: 17 }}>
        <SelectPoulesContainer
          value={props.value}
          selectedValue={props.selectedValue}
          handleSelectChange={props.handleSelectChange}
          pouleOptions={props.pouleOptions}
          bracketOptions={props.bracketOptions}
          tournament={props.tournament}
        />
      </div>
      <div style={{ marginBottom: 17 }}>
        <SelectRounds
          selectedValue={props.selectedRoundsValue}
          options={props.roundOptions}
          handleSelectChange={props.handleSelectRoundsChange}
          tournament={props.tournament}
        />
      </div>
      <div style={{ marginBottom: 15 }}>
        <SelectFields
          value={props.selectedFields}
          selectedValue={props.selectedFieldsValue}
          options={props.fieldOptions}
          handleSelectChange={props.handleSelectFieldsChange}
          tournament={props.tournament}
        />
      </div>
      {props.days.length > 2 &&
        (props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
          props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
          props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
          props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
          props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
          props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
          props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
          props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
          props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE") && (
          <div style={{ marginBottom: 15 }}>
            <SelectDays
              value={props.selectedDays}
              selectedValue={props.selectedDaysValue}
              options={props.dayOptions}
              handleSelectChange={props.handleSelectDaysChange}
              tournament={props.tournament}
            />
          </div>
        )}
      {props.selectedDays.length > 1 &&
        (props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
          props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
          props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
          props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
          props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
          props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
          props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
          props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
          props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE") && (
          <div style={{ marginBottom: 15 }}>
            <FormControlLabel
              control={
                <Radio
                  checked={props.option === 1}
                  onChange={(e) => {
                    props.handleOptionChange(1);
                  }}
                  disabled={moreRoundsThanDays}
                />
              }
              label={
                <span>
                  {languages.schedule.planOneRoundPerDay + " "}
                  {moreRoundsThanDays && (
                    <Tooltip title={languages.schedule.moreRoundsThanDays}>
                      <HelpIcon style={{ height: 15, width: 15 }} />
                    </Tooltip>
                  )}
                </span>
              }
            />
            <FormControlLabel
              control={
                <Radio
                  checked={props.option === 2}
                  onChange={(e) => {
                    props.handleOptionChange(2);
                  }}
                  disabled={!allFieldsHaveEndTimes}
                />
              }
              label={
                <span>
                  {languages.schedule.planMatchesOnAvailableFields}
                  {!allFieldsHaveEndTimes && (
                    <Tooltip
                      title={languages.schedule.notAllFieldsHaveEndTimes}
                    >
                      <HelpIcon style={{ height: 15, width: 15 }} />
                    </Tooltip>
                  )}
                </span>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.preventTwicePerWeek}
                  onChange={(e) => {
                    props.handlePreventTwicePerWeekChange();
                  }}
                />
              }
              label={languages.schedule.preventTwicePerWeek}
            />
            {(props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
              props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
              props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
              props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
              props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
              props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
              props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
              props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
              props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE") && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.planHallShift}
                    onChange={(e) => {
                      props.handleHallShiftChange();
                    }}
                  />
                }
                label={languages.schedule.planHallShift}
              />
            )}
          </div>
        )}
      {props.errorMessage.length > 0 && (
        <div style={{ fontSize: 12, color: "red", padding: "0 2px 10px" }}>
          {props.errorMessage}
        </div>
      )}
      <Button
        size="small"
        variant="outlined"
        color="default"
        onClick={props.divideMatches}
        fullWidth
        style={{ marginBottom: 15 }}
        disabled={
          props.dividing ||
          props.selectedMatches.length === 0 ||
          props.selectedFields.length === 0 ||
          props.tournament.scheduleLocked ||
          props.errorMessage.length > 0 ||
          (props.selectedDays.length > 1 &&
            (props.option === null ||
              (props.option === 1 && moreRoundsThanDays) ||
              (props.option === 2 && !allFieldsHaveEndTimes))) ||
          (props.days.length > 2 &&
            props.selectedDays.length === 0 &&
            (props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
              props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
              props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
              props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
              props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
              props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
              props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
              props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
              props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE")) ||
          false
        }
      >
        {props.selectedMatches.length +
          "/" +
          props.matches.length +
          " " +
          languages.schedule.plan +
          (props.days.length <= 1 ||
          props.tournament[".key"] === "mHZrY1VskDo2Scfnnn6j" ||
          props.tournament[".key"] === "C6KUKTMksMzAuN3h21Er" ||
          props.tournament[".key"] === "PQruJgfJL1KbH5nlJb8x" ||
          props.tournament[".key"] === "NdXzABVuQWZc4Q3GiTHz" ||
          props.tournament[".key"] === "aVP77PkczLUJdBjCIF4i" ||
          props.tournament[".key"] === "45NTFrpDU0hCnZcaQ1AF" ||
          props.tournament[".key"] === "Ob9tQGgviuwdch6opPd7" ||
          props.tournament[".key"] === "ePAgSKQsqpVI2CQd1Ijq" ||
          props.tournament[".key"] === "fcqagH5pFsHyEOg9BwQE"
            ? ""
            : " " +
              languages.schedule.on +
              " " +
              moment
                .unix(
                  props.selectedDay === "0"
                    ? props.tournament.date
                    : (props.daysByKey[props.selectedDay] || {}).date
                )
                .tz(props.tournament.timezone || "Europe/Amsterdam")
                .format(languages.createTournament.dateFormat))}
      </Button>
      {props.resetMatchesEnabled && (
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={props.resetMatches}
          fullWidth
          style={{ marginBottom: 15 }}
          disabled={props.tournament.scheduleLocked}
        >
          {languages.schedule.removeMatchesFromSchedule}
        </Button>
      )}
    </div>
  );
};

export default MatchesPlanner;
